module.exports = __webpack_public_path__ + "static/media/background1b13409f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/background.jpg
// module id = 133
// module chunks = 0